export default __webpack_public_path__ + "static/media/Icons_6.3b4ef40d.svg";